import { Component, HostListener, inject } from '@angular/core';
import { IconName } from '../../../shared/enums/icon-enum';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslatePipe } from '../../../shared/pipes/translate-pipe';
import { IconComponent } from '../../../shared/components/icon/icon.component';

@Component({
  selector: 'app-session-expired-modal',
  imports: [TranslatePipe, IconComponent],
  templateUrl: './session-expired-modal.component.html',
  styleUrl: './session-expired-modal.component.scss',
})
export class SessionExpiredModalComponent {
  public iconName = IconName;
  private dialogRef = inject(MatDialogRef<SessionExpiredModalComponent>);
  private router = inject(Router);

  @HostListener('document:keydown.enter')
  public onEnterPress(): void {
    this.onLogin();
  }

  public onLogin(): void {
    this.dialogRef.close();
    this.router.navigate(['/auth/log-in']);
  }
}
